import React, { Component } from 'react'
import {Message,  Header, Button, Loader, Tab, Table, Icon, Divider, Popup, Label, Checkbox} from 'semantic-ui-react'
import '../App.css'
import {ComposedChart, Line, XAxis, YAxis, CartesianGrid,  Tooltip, Legend, ResponsiveContainer} from 'recharts';
import DefaultTooltipContent from 'recharts/lib/component/DefaultTooltipContent';
import { toast } from '../../node_modules/react-toastify';
import Visualisations from './visualisations';
// import _ from 'lodash'
var moment = require('moment');
require('moment-timezone');

/* 
    This compenent renders the grpah and table visible on the main dashboard. 
    This compenment is called by the main dashboard and relevant data is passed in when it becomes available. 
    This componenet users the recharts library to plot the pgraph using the data passed in.
    This compoenent renders a table with the data passed in.
    Data is capped at 6000 for graph records. After testing it in multiple browesers and machines, this was the largest number most of them could handle without the host maching maxing out it's CPU and/or RAM.
    This compment also incude all the filer graph coneols such as toggle, custom tooltip, custom colors and more.

*/


export default class Graph extends Component{
    constructor(props){
        super(props);
        this.state = {
            graph_data:[],
            activeNode: 0,
            currentData:[],
            currentMeta:{},
            activeKey:{},
            data:{},
            meta:{},
            dataLimit:7000,
            graphModulus:3,
            opacity:{
                'vwc30':1,
                'vwc60':1,
                'temperature':1,

            }
        }
        this.genrateCSV=this.genrateCSV.bind(this);
        this.exportCSVFile  = this.exportCSVFile.bind(this);
        this.convertToCSV = this.convertToCSV.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleHover = this.handleHover.bind(this);
        this.renderNodeControls = this.renderNodeControls.bind(this)
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(props){
        this.setState({activeKey:{}}, () =>{
        })
        if(props.meta && props.data){
            this.setState({meta:props.meta, data:props.data}, () =>{
               
                let currentData = this.state.data[Object.keys(this.state.data)[0]];
                let currentMeta = this.state.meta[Object.keys(this.state.meta)[0]];
                let activeKey = {...this.state.activeKey};
                activeKey[Object.keys(this.state.data)[0]] = true;

                if(activeKey && currentData && currentMeta){
                    this.setState({activeKey:activeKey, currentData:currentData, currentMeta:currentMeta, graphModulus:Math.ceil(currentData.length/this.state.dataLimit)}, () =>{
                        //sorting by nested object
                        // let n = [...this.state.currentData];
                    
                        // n = _.orderBy(n, 'upload_timestamp', 'desc'); // asc or desc
                        // this.setState({currentData:n})
                    })
                }
            })
        }
    }
    handleChange(e, data){
        // e.preventDefault()
        let id = data.id;
        // let value = data.value;
        Object.keys(this.state.meta).forEach(item =>{
            if(id === item){
                let activeKey = {};
                if(id in activeKey){
                    activeKey[id] = !activeKey[id];
                } else{
                    activeKey[id] = true;
                }
                
                this.setState({activeKey:activeKey}, () =>{
                    Object.keys(this.state.activeKey).forEach(key =>{
                        if(this.state.activeKey[key] === true){
                            this.setState({currentData:this.state.data[key], currentMeta: this.state.meta[key]})
                        } else{
                            this.setState({currentData:this.state.data[Object.keys(this.state.meta)[0]], graphModulus:Math.ceil(this.state.data[Object.keys(this.state.meta)[0]].length/this.state.dataLimit), currentMeta: this.state.meta[Object.keys(this.state.meta)[0]] })
                        }
                    })
                    
                })
            }
        })
    

    }
    renderNodeControls(){
        let content = [];
        Object.keys(this.state.data).forEach((key, index) =>{
            if(Object.keys(this.state.data).length > 1){
                content.push(
                    
                        <Checkbox size = {'mini'}style={{marginLeft:'10px'}} toggle label={"Node " + this.state.meta[key].node_num} id = {key} onChange={this.handleChange} checked={this.state.activeKey[key]} />
               
                )
            }

        })
        return content;
    }
    renderTable(){
        var values = [];
            this.state.currentData.forEach((item) => {
                values.push(
                    <Table.Row>
                        <Table.Cell collapsing >
                            {moment(item.upload_timestamp * 1000).format('DD/MM/YY HH:mm')}
                        </Table.Cell>
    
                        <Table.Cell collapsing>
                            {item.vwc30}
                        </Table.Cell>
    
                        <Table.Cell collapsing>
                            {item.vwc60}
                        </Table.Cell>
    
                        <Table.Cell collapsing >
                            {item.temperature}
                        </Table.Cell>
                        <Table.Cell collapsing >
                            {item.battery}
                        </Table.Cell>
                        <Table.Cell collapsing >
                            {item.count}
                        </Table.Cell>
                    </Table.Row>
                    )
    
            })
        return values;
        

    }


    renderInfo(){
        if(this.state.meta && this.state.data){
            let data = this.state.currentData;
            if(data && data.length > 0){
                let info = [];
                let time = data[0].upload_timestamp || null;  
                time = moment(time * 1000).format('DD/MM/YY HH:mm:ss')
                info.push(
                    <Visualisations average ={this.props.average} activeKey = {this.state.activeKey} range={this.props.range} getMin = {this.props.getMin} meta ={this.state.currentMeta} data = {this.state.currentData} time = {time}getMax = {this.props.getMax}/>
                )
    
                return info;
            }

            
        }
        
    }
    
     convertToCSV(objArray) {
        var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        var str = '';

        for (var i = 0; i < array.length; i++) {
            var line = '';
            for (var index in array[i]) {
                if (line !== '') line += ','

                line += array[i][index];
            }

            str += line + '\r\n';
        }

        return str;
    }

    exportCSVFile(headers, fileTitle) {
     
        let data = [];
        this.state.currentData.forEach((d,i) =>{
            // let parsedDate = moment(d.upload_timestamp * 1000).format('DD/MM/YY HH:mm');
            data.push(d)
            data[i]["parsed_date"] = (moment(d.upload_timestamp * 1000).format('DD/MM/YY HH:mm'))
            // data[i].upload_timestamp = parsedDate;
            // d.upload_timestamp = moment(d.upload_timestamp * 1000).format('DD/MM/YY HH:mm')
        })
        if (headers) {
            data.unshift(headers);
        }
    
        var csv = this.convertToCSV(data);
        var d = new Date();
        var exportedFilenmae = fileTitle + ' '+ d  + '.csv' || 'export.csv';
    
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmae);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    genrateCSV(e){
        toast.info("Generating CSV...")
        var headers = {
            forest_name: 'NodeID'.replace(/,/g, ''), // remove commas to avoid errors
            temperature: "Temperature C 10cm",
            vwc30: "VWC % 30cm",
            vwc60: "VWC % 60cm",
            upload_timestamp:"Upload Timestamp (UTC)",
            sample_count:"Samples",
            battery:"Battery %",
            parsed_time:"Upload Date",
        };
        this.exportCSVFile(headers ,this.state.currentMeta.forest_name);
    }
      
    handleClick(o) {
        const { dataKey } = o;
        const { opacity } = this.state;
        if(opacity[dataKey] === 1){
            this.setState({
                opacity: { ...opacity, [dataKey]: 0 }
            });
        } else{
            this.setState({
                opacity: { ...opacity, [dataKey]: 1 }
            });
        }
    }
    handleHover(e){

    }



    render(){  
    const { opacity } = this.state;
    const CustomTooltip = props => {
        // payload[0] doesn't exist when tooltip isn't visible
        if (props.payload && props.payload[0] != null) {
            // mutating props directly is against react's conventions
            // so we create a new payload with the name and value fields set to what we want
            let newPayload = []
            this.props && this.props.count > 0 && this.props.count < this.state.dataLimit ?  
            
            newPayload= [
            {
                name: 'Date',
                // all your data which created the tooltip is located in the .payload property
                value: moment(props.payload[0].payload.upload_timestamp * 1000).format('DD/MM/YY HH:mm'),
                // you can also add "unit" here if you need it
            },{
                name:"Battery",
                value:props.payload[0].payload.battery + " %",
                color:"gray"
            },
            ...props.payload,
            ]
            :
            newPayload= [
                {
                    name: 'Date',
                    // all your data which created the tooltip is located in the .payload property
                    value: moment(props.payload.slice(-(this.state.dataLimit-1))[0].payload.upload_timestamp * 1000).format('DD/MM/YY HH:mm'),
                    // you can also add "unit" here if you need it
                },{
                    name:"Battery",
                    value:props.payload.slice(-(this.state.dataLimit-1))[0].payload.battery + " %",
                    color:"gray"
                },
                ...props.payload,
            ]
        
            // we render the default, but with our overridden payload
            return <DefaultTooltipContent payload={newPayload} />;
        }
        
        // we just render the default
        return <DefaultTooltipContent {...props} />;
        };
        const panes = [
            { menuItem: 'Graph', render: () => <Tab.Pane attached={false}>
                
                 <div id = "chartContainer" className = "">
                 <Header id = 'renderedNode'>{this.state.currentMeta && this.state.currentMeta.forest_name}
                    <sub>
                        
                        <Label color='orange' size={'mini'}>
                            Node {this.state.currentMeta.node_num}
                        </Label>
                        <div style={{float:"right"}}>
                            {this.renderNodeControls()}
                        </div>
                    </sub>
                 </Header>
                 
                 
                 {this.props && this.props.count > 0 && this.props.count < this.state.dataLimit ?  
                 <div>
                   <ResponsiveContainer height={320} width='100%'>
                    {/* {console.log(this.state.data)} */}
                        <ComposedChart  data={this.state.currentData} type={''} reverseStackOrder={false}
                           margin={{top: 5, right: 0, left: 0, bottom: 5}}>
                            <XAxis dataKey="upload_timestamp" 
                            // name = 'Time'
                            domain = {['auto', 'auto']}
                            tickFormatter = {(unixTime)  => moment(unixTime * 1000).format('DD/MM HH:mm')}
                            type = 'number'
                            
                            />
                            <Tooltip headerFormat= '' content={CustomTooltip} cursor={{ stroke: 'purple', strokeWidth: 1 }}
                                     
                            

                            />
                            
                            <YAxis yAxisId="left" label={{ value: "Volumetric Water Content (VWC) %", angle: -90, position: 'center' }}/>
                            <CartesianGrid strokeDasharray="8 8"/>
                            <YAxis yAxisId="right" orientation="right" label={{ value: "Temp °C", angle: -40, position: 'insideRight' }} />
                            <Legend id={'legends'}iconType={'square'} onClick={this.handleClick} onMouseEnter={this.handleHover}/>
                            
                            <Line yAxisId="left"  dot={false} type="monotone" dataKey="vwc30" fill='teal'stroke="teal" strokeOpacity={opacity.vwc30}/>
                            <Line yAxisId="left" dot={false} type="monotone" dataKey="vwc60" fill='blue' stroke = 'blue' strokeOpacity={opacity.vwc60}/>
                            <Line yAxisId="right" dot={false} type="monotone" dataKey="temperature" fill='orange' stroke="orange" strokeOpacity={opacity.temperature}/>  
                           
                            {/* <Line yAxisId="left" dot={false} type="" dataKey="battery" fill='white' stroke="black"/> */}
                           
                        </ComposedChart>
                        
                    </ResponsiveContainer>
                     <Popup basic style={{marginLeft:'55%', opacity:'0.5'}}  point ={false} inverted position='left center' trigger={<a><Icon circular style={{marginLeft:'98%'}}name='info' /></a>} content='Click on the legends to toggle data' />
                     </div>
                    :
                    <div>
                        <ResponsiveContainer height={350} width='100%'>
                            <ComposedChart  data={this.state.currentData.filter((_, i) => {return i % this.state.graphModulus === 0} )} reverseStackOrder={false}
                            margin={{top: 5, right: 0, left: 0, bottom: 5}}>
                                <XAxis dataKey="upload_timestamp"
                                // name = 'Time'
                                domain = {['auto', 'auto']}
                                tickFormatter = {(unixTime)  => moment(unixTime * 1000).format('DD/MM HH:mm')}
                                type = 'number'
                                
                                />
                                <Tooltip headerFormat= '' content={CustomTooltip} cursor={{ stroke: 'red', strokeWidth: 1 }}
                                        
                                

                                />
                                <YAxis yAxisId="left" label={{ value: "Volumetric Water Content (VWC) %", angle: -90, position: 'insideLeft' }}/>
                                <CartesianGrid strokeDasharray="8 8"/>
                                <YAxis yAxisId="right" orientation="right" label={{ value: "Temp °C", angle: -40, position: 'insideRight' }} />

                                <Legend iconType={'square'} onClick={this.handleClick}/>
                                <Line yAxisId="left"  dot={false} type="monotone" dataKey="vwc30" fill='teal'stroke="teal" strokeOpacity={opacity.vwc30}/>
                                <Line yAxisId="left" dot={false} type="monotone" dataKey="vwc60" fill='blue' stroke = 'blue' strokeOpacity={opacity.vwc60}/>
                                <Line yAxisId="right" dot={false} type="monotone" dataKey="temperature" fill='orange' stroke="orange" strokeOpacity={opacity.temperature}/>  
                                {/* <Line yAxisId="left" dot={false} type="" dataKey="battery" fill='white' stroke="black"/> */}
                                
                            </ComposedChart>
                        </ResponsiveContainer>
                        <Popup basic style={{marginLeft:'55%', opacity:'0.5'}}  point ={false} inverted position='left center' trigger={<a><Icon circular style={{marginLeft:'98%'}}name='info' /></a>} content='Click on the legends to toggle data' />
                        {this.props.count && 
                            <Message info style={{textAlign:'center'}}>
                            <Message.Header>Part of dataset has been omitted from the graph due to its size.</Message.Header>                     
                            <Button size = "mini" icon onClick={this.genrateCSV}>
                                Download full dataset CSV | 
                                <Icon name='file excel outline' />
                            </Button>

                            </Message>
                        }
                    </div>
                


                 }
                    
                    {this.props.isFetching === true ? <Loader active small content = 'Fetching Data..'/> : null }
                    <Divider/>


                    <div>
                    {this.props.isFetching === true ? <Icon size='large' loading name='spinner' content = "Fetching Data.." /> : null }
                        {this.renderInfo()}

                    </div>
                    
                </div>
                

            </Tab.Pane> },
            { menuItem: 'Table', render: () => <Tab.Pane attached={false}>
            {this.props.data && 
            <div style ={{overflowY:''}}>
            <Header>{this.props.title}</Header>


                    

                {this.props && this.props.count > 0 && this.props.count < 5000 ? 
                    
                    <div>
                        <div  style={{textAlign:'right'}}>
                            <Button size = "mini" icon onClick={this.genrateCSV}>
                                Download CSV | 
                                <Icon name='file excel outline' />
                            </Button>
                        
                        </div>
                
                    <Table invereted celled striped>                   
                        <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell rowSpan='2'>Upload Date</Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>vwc30 %</Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>vwc60 %</Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Temperature °C</Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Battery %</Table.HeaderCell>
                            <Table.HeaderCell rowSpan='2'>Samples</Table.HeaderCell>
                        </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.props.data &&  
                                this.renderTable() 
                            }
                        </Table.Body>
                    </Table>
                    </div>
                    
                    :

                    this.props.count ? 

                    <Message info style={{textAlign:'center'}}>
                     <Message.Header>The dataset you've requested is too large to display on your web page. </Message.Header>                     
                    <Message.Item>You can download the it as a CSV file below</Message.Item>
                    <Button size = "mini" icon onClick={this.genrateCSV}>
                        Download CSV | 
                        <Icon name='file excel outline' />
                    </Button>

                    </Message> : null
                }

            </div>
            }
    </Tab.Pane>


             }
          ]     
          return(
              
            <div  className= "column" >
                <Tab menu={{ color:'', inverted: false, attached: false, tabular: false, fluid:true, secondary:true }} panes={panes} style={{marginTop:"0px"}}/>
            </div>


          )

    }
}



// WEBPACK FOOTER //
// ./src/components/graph.js